import { useMemo } from 'react';
import type { Highlight, Period } from '@casetrace/shared';
import { useCaseHighlights } from '../../hooks/use-case-highlights';
import { useCasePeriods } from '../../hooks/use-case-periods';

export function useStoryData(caseId: string): {
  readonly highlights: readonly Highlight[];
  readonly periods: readonly Period[];
  readonly isLoading: boolean;
} {
  const highlightsQuery = useCaseHighlights(caseId);
  const periodsQuery = useCasePeriods(caseId);

  const highlights = useMemo((): readonly Highlight[] => {
    const map = highlightsQuery.data;
    if (!map) return [];
    return [...map.values()].sort((a, b) => a.timestamp.localeCompare(b.timestamp));
  }, [highlightsQuery.data]);

  return {
    highlights,
    periods: periodsQuery.data ?? [],
    isLoading: highlightsQuery.isLoading || periodsQuery.isLoading,
  };
}
